import { Box } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import Remove from "@material-ui/icons/Remove";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchBasket, updateBasket } from "../../services/basket/actions";
import "./Product.scss";

const getBasketAmount = (productId, basketProducts) => {
  if (basketProducts.length > 0) {
    for (let i in basketProducts) {
      // dit heeft mogelijk een andere manier nodig om de store te benaderen
      if (parseInt(basketProducts[i].product_id) === parseInt(productId)) {
        return basketProducts[i].number;
      }
    }
  }
  return 0;
};

function ProductAmountCounter(props) {
  const [submitted, setSubmitted] = useState(false);
  const [count, setCount] = useState(
    getBasketAmount(props.productId, props.basketProducts)
  );
  const [inputOpen, closeInput] = useState(false);
  const [value, setValue] = useState(null);

  useEffect(() => {
    let count = getBasketAmount(props.productId, props.basketProducts);
    setCount(count);
    setValue(count);
    // disable fetchAll dependency warning
    // eslint-disable-next-line
  }, [props.productId]);

  const handleChange = (event) => {
    setSubmitted(false);

    if (event.target.value == "") {
      //do this to avoid item being instantly deleted when backspaced in basket
      var location = window.location.href.substring(
        window.location.href.lastIndexOf("/") + 1
      );
      if (location == "basket") {
        setValue(null);
        return;
      }
      props.updateBasket(props.currentLocation.id, props.productId, 0);
      props.fetchBasket(props.currentLocation.id, props.userId);
      setCount(0);
      setValue(null);
      return;
    }
    setCount(parseInt(event.target.value));
    setValue(parseInt(event.target.value));
    props.updateBasket(
      props.currentLocation.id,
      props.productId,
      parseInt(event.target.value)
    );
    if (event.target.value > 0) {
      setSubmitted(true);
    }
    setTimeout(() => {
      setSubmitted(false);
      closeInput(!inputOpen);
    }, 2000);
  };

  const handleClickAdd = () => {
    setSubmitted(false);
    props.updateBasket(props.currentLocation.id, props.productId, count + 1);
    props.fetchBasket(props.currentLocation.id, props.userId);
    setCount(count + 1);
    setValue(count + 1);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      closeInput(!inputOpen);
    }, 2000);
  };

  const handleClickMinus = () => {
    if (count - 1 < 0) {
      return;
    }
    setSubmitted(false);
    props.updateBasket(props.currentLocation.id, props.productId, count - 1);
    props.fetchBasket(props.currentLocation.id, props.userId);
    setCount(count - 1);
    setValue(count - 1);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      closeInput(!inputOpen);
    }, 2000);
  };

  const whichScreen = (input_class) => {
    if (props.screenType === "confirmOrder") {
      return (
        <Box textAlign="center">
          <p>{count}</p>
        </Box>
      );
    } else {
      return (
        <div className="counterDiv">
          {props.screenType === "Assortiment" ? (
            <button onClick={handleClickMinus} className="buttonRemove">
              <Remove />
            </button>
          ) : null}
          <Box textAlign="center">
            <input
              className={input_class}
              placeholder={count}
              value={value}
              onChange={handleChange}
              type="number"
              min="0"
              max="10000"
            />
          </Box>
          {props.screenType === "Assortiment" ? (
            <button onClick={handleClickAdd} className="buttonAdd">
              <Add />
            </button>
          ) : null}
        </div>
      );
    }
  };

  let input_class = submitted ? "submitted" : "notSubmitted";
  if (props.productId) {
    return whichScreen(input_class);
  } else {
    return (
      <Box p={1}>
        <p>Niks</p>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    basketProducts: state.basket.products,
    currentLocation: state.currentInformation.current_location,
    userId: state.login.data.user_id,
  };
}

export default connect(mapStateToProps, {
  updateBasket,
  fetchBasket,
})(ProductAmountCounter);
